import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bell",
  "use": "icon-bell-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bell\"><path d=\"M511.718 1022.589c56.45 0 100.198-43.749 100.198-100.199H411.237c.282 56.45 44.03 100.199 100.48 100.199zm329.102-326.28V435.51c0-156.648-111.206-288.176-256.282-322.61V80.159c0-36.41-20.04-69.151-54.756-76.49-50.24-11.854-91.167 26.532-91.167 75.643v34.717C293.54 147.616 182.333 279.144 182.333 435.793V696.59L82.981 798.765v50.805H939.89v-51.087l-99.07-102.174zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol